
import BonusGameScene from './bonusgame_scene';
import SuperBonusGameScene from './superbonusgame_scene';
import dull_bonus from 'dull_bonus'

export default function construct(spec) {
    
    const bonusGameScene = new BonusGameScene(spec.specification.secondChanceTreshold);
    bonusGameScene.visible = false;

    const superBonusGameScene = new SuperBonusGameScene();
    superBonusGameScene.visible = false;
    
    const slotScene = { view : new PIXI.Container }
    slotScene.view.setWinFlowCallback = ()=>{}
    
    return {
        slotScene,
        barrel : {
            container : new PIXI.Container,
            update : ()=>{},
            setCurrentElements : ()=>{},
            setDelegate : ()=>{},
        },
        
        bonusScene: {
            view: bonusGameScene,
            z:3
        },
        superBonusScene: {
            view: superBonusGameScene,
            z:4
        },
        reactive
    };
}

const reactive = (space, construct) => {
    const bonus = construct.bonusScene.view;

    space.s( "ticker" ).on( seconds => {
        bonus.filter.uniforms.iTime += seconds;
        bonus.filter.uniforms.iTime %= 1000
    } );

    space.s( "slot:showWinComplete" ).to( space.s("ui:start") );
    space.s( "bonus:endingComplete" ).to( space.s("ui:finish" ) );
    space.s( "superbonus:endingComplete" ).to( space.s("ui:finish" ) );
    
    dull_bonus()
};






// WEBPACK FOOTER //
// ./src/construct.es6